export default __webpack_public_path__ + "static/media/thumbnail.80d53684.png";